import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { DialogContentText, Grid, Typography } from '@mui/material';
import moment from 'moment';
import {
  DialogDefaultV2,
  InputV2,
  DefaultSelectV2,
  NumberInputV2,
  ArquivoContainerV2,
  DatePickerV2,
  MalhaSelectV2,
} from '../../../components/v2';
import * as selectorsControleCaixas from '../../../store/controleCaixa/reducer';
import * as actionsControleCaixas from '../../../store/controleCaixa/actions';
import * as selectorsAuth from '../../../store/auth/reducer';

const getSchema = (values) => {
  let schema = {
    tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    dataEmissao: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    dataRecebimento: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  };

  if (values.tipo === 'CONTRATO') {
    schema = {
      ...schema,
      numNotaFiscal: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      contrato: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      malhaId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      apro: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      hd: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      valorBruto: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      issPercentage: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      inssPercentage: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  } else {
    schema = {
      ...schema,
      valorRecebido: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      descricao: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  return schema;
};

const FormularioReceita = ({ saveControleCaixa, updateControleCaixa, selectedControleCaixa, open, id, onClose, findControleCaixaById, authData, cancelarControleCaixa, liquidarControleCaixa }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [openCancelar, setOpenCancelar] = useState(false);
  const [openLiquidar, setOpenLiquidar] = useState(false);
  const [openALiquidar, setOpenALiquidar] = useState(false);

  useEffect(() => {
    if (open && !id) {
      setValues({
        criadoPorId: authData.id,
        criadoPorName: authData.nome,
        dataEmissao: moment().valueOf(),
        dataCriacaoFormat: moment().format('DD/MM/YYYY HH:mm'),
        dataRecebimento: moment().add(30, 'days').valueOf(),
        tipo: 'CONTRATO',
        status: 'A_LIQUIDAR',
      });
    }
  }, [open, authData, id]);

  useEffect(() => {
    if (id) findControleCaixaById(id, 'receitas');
  }, [id, findControleCaixaById]);

  useEffect(() => {
    if (id && selectedControleCaixa && id === selectedControleCaixa.id) {
      setValues(selectedControleCaixa);
    }
  }, [id, selectedControleCaixa]);

  const readOnly = values.cancelada || values.status === 'LIQUIDADO';

  const onSave = () => {
    const erros = validate(values, getSchema(values));
    setErrors(erros || {});
    if (!erros) {
      const callback = () => onCloseLocal(true);
      if (values.id) updateControleCaixa(values, 'receitas', callback);
      else saveControleCaixa(values, 'receitas', callback);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    onClose(isSave);
  };

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleValorBruto = (newValorBruto) => {
    const valorBruto = newValorBruto || 0;
    const issReal = values.issPercentage ? valorBruto * values.issPercentage / 100 : 0;
    const inssReal = values.inssPercentage ? valorBruto * values.inssPercentage / 100 : 0;
    const valorLiquido = valorBruto - issReal - inssReal;
    const valorRecebido = values.taxaJuros ? valorLiquido - values.taxaJuros : valorLiquido;
    setValues({ ...values, valorBruto, issReal, inssReal, valorLiquido, valorRecebido });
  };

  const handleIss = (newIssPercentage) => {
    const valorBruto = values.valorBruto || 0;
    const issPercentage = newIssPercentage || 0;
    const issReal = valorBruto * issPercentage / 100;
    const inssReal = values.inssReal || 0;
    const valorLiquido = valorBruto - issReal - inssReal;
    const valorRecebido = values.taxaJuros ? valorLiquido - values.taxaJuros : valorLiquido;
    setValues({ ...values, issPercentage, issReal, valorLiquido, valorRecebido });
  };

  const handleInss = (newInssPercentage) => {
    const valorBruto = values.valorBruto || 0;
    const issReal = values.issReal || 0;
    const inssPercentage = newInssPercentage || 0;
    const inssReal = valorBruto * inssPercentage / 100;
    const valorLiquido = valorBruto - issReal - inssReal;
    const valorRecebido = values.taxaJuros ? valorLiquido - values.taxaJuros : valorLiquido;
    setValues({ ...values, inssPercentage, inssReal, valorLiquido, valorRecebido });
  };

  const handleTaxa = (newTaxaJuros) => {
    const valorLiquido = values.valorLiquido || 0;
    const taxaJuros = newTaxaJuros || 0;
    const valorRecebido = valorLiquido - taxaJuros;
    setValues({ ...values, taxaJuros, valorRecebido });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Receita"
      cancelMessage="Fechar"
      confirmMessage="Salvar"
      readOnly={readOnly}
      maxWidth="md"
      headerAction={[
        {
          onClick: () => setOpenCancelar(true),
          title: 'Cancelar',
          show: (values.cancelada === undefined || values.cancelada === false) && values.id !== undefined && values.status === 'A_LIQUIDAR',
        },
        {
          onClick: () => setOpenLiquidar(true),
          title: 'Liquidar',
          show: values.status === 'A_LIQUIDAR' && values.id !== undefined && values.cancelada === false,
        },
        {
          onClick: () => setOpenALiquidar(true),
          title: 'A Liquidar',
          show: values.status === 'LIQUIDADO' && values.id !== undefined && values.cancelada === false,
        },
      ]}
    >
      <Grid container spacing={3}>
        {values.cancelada && (
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ color: 'error.main', fontStyle: 'italic' }}>
              **** Receita Cancelada por {values.modificadoPorName} em {values.dataUltimaAtualizacaoFormat}
            </Typography>
          </Grid>
        )}
        {values.status === 'LIQUIDADO' && (
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ color: 'error.main', fontStyle: 'italic' }}>
              **** Receita Liquidada por {values.modificadoPorName} em {values.dataUltimaAtualizacaoFormat}
            </Typography>
          </Grid>
        )}
        <Grid size={{ xs: 3 }}>
          <DefaultSelectV2
            label="Tipo"
            error={!!(errors && errors.tipo)}
            isRequired
            options={[{ id: 'CONTRATO', nome: 'Contrato' }, { id: 'ESTORNO', nome: 'Estorno' }, { id: 'OUTROS', nome: 'Outros' }]}
            onSelect={(event) => {
              const tipo = event.target.value;
              setValues({
                tipo,
                criadoPorId: authData.id,
                criadoPorName: authData.nome,
                dataEmissao: moment().valueOf(),
                dataCriacaoFormat: moment().format('DD/MM/YYYY HH:mm'),
                dataRecebimento: tipo === 'CONTRATO' ? moment().add(30, 'days').valueOf() : moment().valueOf(),
                arquivos: values.arquivos,
                descricao: values.descricao,
                observacao: values.observacao,
                status: values.status,
              });
              setErrors({});
            }}
            value={values.tipo}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <DatePickerV2
            error={!!(errors && errors.dataEmissao)}
            isRequired
            label="Data da Emissão"
            onChange={(dataEmissao) => setValues({ ...values, dataEmissao: dataEmissao.valueOf() })}
            value={values.dataEmissao}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <DatePickerV2
            label="Data do Recebimento"
            error={!!(errors && errors.dataRecebimento)}
            isRequired
            onChange={(data) => setValues({ ...values, dataRecebimento: data.valueOf() })}
            value={values.dataRecebimento}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <DefaultSelectV2
            label="Status"
            options={[{ id: 'A_LIQUIDAR', nome: 'A Liquidar' }, { id: 'LIQUIDADO', nome: 'Liquidado' }]}
            value={values.status}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2
            error={!!(errors && errors.numNotaFiscal)}
            isRequired={values.tipo === 'CONTRATO'}
            label="Nº Nota Fiscal"
            name="numNotaFiscal"
            onChange={handleChange}
            value={values.numNotaFiscal}
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2
            error={!!(errors && errors.contrato)}
            isRequired={values.tipo === 'CONTRATO'}
            label="Nº Contrato"
            name="contrato"
            onChange={handleChange}
            value={values.contrato}
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <MalhaSelectV2
            error={!!(errors && errors.malhaId)}
            isRequired={values.tipo === 'CONTRATO'}
            onSelect={(value) => setValues({ ...values, malhaId: value })}
            value={values.malhaId}
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.apro)}
            isRequired={values.tipo === 'CONTRATO'}
            label="APRO"
            onChange={(valor) => setValues({ ...values, apro: valor })}
            value={values.apro}
            decimalScale={0}
            prefix=""
            thousandSeparator=""
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.hd)}
            isRequired={values.tipo === 'CONTRATO'}
            label="HD"
            onChange={(valor) => setValues({ ...values, hd: valor })}
            value={values.hd}
            decimalScale={0}
            prefix=""
            thousandSeparator=""
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.valorBruto)}
            isRequired={values.tipo === 'CONTRATO'}
            label="Valor Bruto"
            onChange={handleValorBruto}
            value={values.valorBruto}
            format="##,######"
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.issPercentage)}
            isRequired={values.tipo === 'CONTRATO'}
            label="ISS (%)"
            onChange={handleIss}
            value={values.issPercentage}
            format="##,######"
            prefix=""
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2 label="Valor ISS" disabled value={values.issReal} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.inssPercentage)}
            isRequired={values.tipo === 'CONTRATO'}
            label="INSS (%)"
            onChange={handleInss}
            value={values.inssPercentage}
            format="##,######"
            prefix=""
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2 label="Valor INSS" disabled value={values.inssReal} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2 label="Valor Líquido" disabled value={values.valorLiquido} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            label="Taxa/Juros"
            onChange={handleTaxa}
            value={values.taxaJuros}
            format="##,######"
            disabled={readOnly || values.tipo !== 'CONTRATO'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.valorRecebido)}
            isRequired={values.tipo !== 'CONTRATO'}
            disabled={readOnly || values.tipo === 'CONTRATO'}
            label="Valor Recebido"
            onChange={(valorRecebido) => setValues({ ...values, valorRecebido })}
            value={values.valorRecebido}
            format="##,######"
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <InputV2 label="Município" name="municipio" onChange={handleChange} value={values.municipio} disabled={readOnly} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            label="US"
            onChange={(valor) => setValues({ ...values, us: valor })}
            value={values.us}
            disabled={readOnly}
            decimalScale={0}
            prefix=""
            thousandSeparator=""
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <NumberInputV2
            label="Valor US"
            onChange={(valorUs) => setValues({ ...values, valorUs })}
            value={values.valorUs}
            format="##,######"
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2 label="Criado Por" disabled value={values.criadoPorName} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2 label="Data Criação" disabled value={values.dataCriacaoFormat} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2 label="Data Última Atualização" disabled value={values.dataUltimaAtualizacaoFormat} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            error={!!(errors && errors.descricao)}
            isRequired={values.tipo !== 'CONTRATO'}
            onChange={handleChange}
            value={values.descricao}
            rows={3}
            multiline
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2 label="Observação" name="observacao" onChange={handleChange} value={values.observacao} rows={3} multiline disabled={readOnly} />
        </Grid>
        <ArquivoContainerV2
          arquivos={values.arquivos || []}
          onSave={(arquivos) => setValues({ ...values, arquivos })}
          disabled={readOnly}
        />
      </Grid>
      <DialogDefaultV2
        open={openCancelar}
        handlerCancel={() => setOpenCancelar(false)}
        handlerConfirm={() => { setOpenCancelar(false); cancelarControleCaixa(values.id, 'receitas', () => onCloseLocal(true)); }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja realmente cancelar a receita?</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={openLiquidar}
        handlerCancel={() => setOpenLiquidar(false)}
        handlerConfirm={() => { setOpenLiquidar(false); liquidarControleCaixa(values.id, 'receitas', 'LIQUIDADO', () => onCloseLocal(true)); }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja realmente liquidar a receita?</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={openALiquidar}
        handlerCancel={() => setOpenALiquidar(false)}
        handlerConfirm={() => { setOpenALiquidar(false); liquidarControleCaixa(values.id, 'receitas', 'A_LIQUIDAR', () => onCloseLocal(true)); }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja realmente alterar o status para 'A Liquidar'?</DialogContentText>
      </DialogDefaultV2>
    </DialogDefaultV2>
  );
};

const mapStateToProps = (state) => ({
  selectedControleCaixa: selectorsControleCaixas.getSelectedControleCaixa(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsControleCaixas }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormularioReceita);
